import { Box, Tabs as MaterialTabs, Tab } from '@mui/material';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { useState } from 'react';

const CustomTabPanel = observer(function CustomTabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tabpanel-${index}`}
            aria-labelledby={`tab-${index}`}
            style={value !== index ? { display: 'none' } : undefined}
            {...other}
        >
            <Box>{children}</Box>
        </div>
    );
});

CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired
};

function a11yProps(index) {
    return {
        id: `tab-${index}`,
        'aria-controls': `tabpanel-${index}`
    };
}

const Tabs = observer(function Tabs({ tabs, todasTabsComMesmaAltura = false }) {
    const [currentTab, setCurrentTab] = useState(0);

    const handleChange = (_, newValue) => {
        setCurrentTab(newValue);
    };

    // Modo com mesma altura
    if (todasTabsComMesmaAltura) {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', width: '100%', minHeight: 0 }}>
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <MaterialTabs
                        value={currentTab}
                        onChange={handleChange}
                    >
                        {tabs.map(({ id, titulo }, index) => (
                            <Tab
                                key={id}
                                label={titulo}
                                {...a11yProps(index)}
                                sx={{ px: 2 }}
                            />
                        ))}
                    </MaterialTabs>
                </Box>
                <Box sx={{ flex: 1, overflow: 'auto', position: 'relative' }}>
                    {tabs.map(({ id, conteudo }, index) => (
                        <Box
                            key={id}
                            role="tabpanel"
                            hidden={currentTab !== index}
                            id={`tabpanel-${index}`}
                            aria-labelledby={`tab-${index}`}
                            sx={{
                                height: '100%',
                                overflow: 'auto',
                                display: currentTab !== index ? 'none' : 'block'
                            }}
                        >
                            {conteudo}
                        </Box>
                    ))}
                </Box>
            </Box>
        );
    }

    return (
        <Box sx={{ width: '100%' }}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <MaterialTabs
                    value={currentTab}
                    onChange={handleChange}
                >
                    {tabs.map(({ id, titulo }, index) => (
                        <Tab
                            key={id}
                            label={titulo}
                            {...a11yProps(index)}
                            sx={{ px: 2 }}
                        />
                    ))}
                </MaterialTabs>
            </Box>
            {tabs.map(({ id, conteudo }, index) => (
                <CustomTabPanel
                    key={id}
                    value={currentTab}
                    index={index}
                >
                    {conteudo}
                </CustomTabPanel>
            ))}
        </Box>
    );
});

Tabs.propTypes = {
    tabs: PropTypes.array,
    todasTabsComMesmaAltura: PropTypes.bool
};

export default Tabs;
